import React from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import {UserGetSchema} from '../../../../api/DBSchema/User';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';
import {dateAndTimeToString} from '../../../../utils/utils';
import SMCTable from '../../../../components/core/SMCTable/SMCTable';
import Sepperator from '../../../../components/Simple/Sepperator';
import SMCLabel from '../../../../components/Simple/SMCLabel';

const pageSchema = UserGetSchema.pages.status;
const pageId = pageSchema.pageId;

function UserStatus({
    userObject
}) {
    const { t } = useTranslation();

    const pageData = userObject[pageId];

    const createdDate = pageData[pageSchema.createdDate];
    const modifiedDate = pageData[pageSchema.modifiedDate];
    const sessionsDataList = pageData[pageSchema.statusDataList];
    
    const sessionsDataSchema = pageSchema.statusDataSchema;

    return (
        <EditorLayout>
            <SMCTextInput
                readOnly
                value={dateAndTimeToString(createdDate, true)}
                label={t('SMP.USERS.TABLE.PAGES.STATUS.CREATED')}
            />
            <SMCTextInput
                readOnly
                value={dateAndTimeToString(modifiedDate, true)}
                label={t('SMP.USERS.TABLE.PAGES.STATUS.LAST_MODIFIED')}
            />
            <Sepperator />
            <SMCLabel bold fontSize="16px">{t('SMC_WELCOME_TAB1')}</SMCLabel>
            <SMCTable
                columns={[
                    {id: 'count',       header: '#',                                                                                      width: 32,  align: 'center', Cell: ({index}) => (index + 1)                        },
                    {id: 'loginTime',   header: t('SMP.USERS.TABLE.PAGES.STATUS.LOGIN_TIME'), accessor: sessionsDataSchema.lastUsedTime,  width: 180,                  Cell: ({value}) => (dateAndTimeToString(value, true)) },
                    {id: 'application', header: t('SMP.USERS.TABLE.PAGES.STATUS.APP'),        accessor: sessionsDataSchema.appName,       width: 85,                                                                         },
                    {id: 'sourceIp',    header: t('SMP.USERS.TABLE.PAGES.STATUS.SOURCE_IP'),  accessor: sessionsDataSchema.remoteAddress, width: 90,                                                                         },
                ]}
                content={sessionsDataList}
                hasCheckboxColumn={false}
                width={500}
            />
        </EditorLayout>
    )
}

export default UserStatus;